import { GetterTree, MutationTree } from 'vuex';
import actions from '@/store/campaignSitesAction';
import { RootState } from '@/types/index';
import { ICampaignSitesState } from '@/types/campaign/sites';
import { cloneDeep } from 'lodash';

const state: ICampaignSitesState = {
  sites: {
    byDomain: {},
    allDomains: []
  },
};

const mutations: MutationTree<ICampaignSitesState> = {
  setSites(state, sites) {
    state.sites = cloneDeep(sites);
  },
};

const getters: GetterTree<ICampaignSitesState, RootState> = {
  getSites(state) {
    return state.sites;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
